import { graphql } from "../__generated__/gql";

export const GET_SITC_PRODUCTS_QUERY = graphql(`
  query GetSITCProducts($servicesClass: ServicesClass) {
    section: productSitc(productLevel: 1, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    twoDigit: productSitc(productLevel: 2, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    fourDigit: productSitc(productLevel: 4, servicesClass: $servicesClass) {
      ...ProductMetadata
    }
  }

`);

export default GET_SITC_PRODUCTS_QUERY;
